import React from "react";
import ReactDOM from "react-dom";
import Search from "./react/Search";
document.querySelectorAll('form#search').forEach((dom) => {
    ReactDOM.render(React.createElement(Search, {}, null), dom);
});
